import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Layout from '../components/layout';
import { usePrivacyHeroImage } from '../hooks/usePrivacyHeroImage';
import TermsAndPrivacy from '../components/content/termsConditions/terms.privacy.base';

const CookiesPolicy = function ({ location, pageContext }) {
  const { country, language } = pageContext;
  const { imageFileName, imagePosition, imageTitle, imageAlt } =
    usePrivacyHeroImage(country);
  return (
    <Layout
      pageTitle="web.popup.cookies"
      imageFileName={imageFileName}
      imageTitle={imageTitle}
      imageAlt={imageAlt}
      primaryText="web.popup.cookies"
      secondaryText="web.privacy.conditions.secondary"
      location={location}
      country={country}
      language={language}
      imagePosition={imagePosition}
    >
      <TermsAndPrivacy cookies />
    </Layout>
  );
};

CookiesPolicy.propTypes = {
  location: PropTypes.shape({}).isRequired,
  pageContext: PropTypes.shape({
    country: PropTypes.string,
    language: PropTypes.string,
  }),
};

CookiesPolicy.defaultProps = {
  pageContext: {
    country: undefined,
    language: undefined,
  },
};

export default CookiesPolicy;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
